export default __webpack_public_path__ + "static/media/bagel.9c27951f.jpg";